import React from "react";

export default function AprilFoolDay3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-apr31{fill:#e82649}.cls-apr33{fill:#feb300}.cls-apr34{fill:#ef9f00}.cls-apr35{fill:#db1640}.cls-apr37{fill:#f9c358}"
            }
          </style>
        </defs>
        <path
          d="M1387.51 1932.14H621.32c-69.1 0-125.32-56.22-125.32-125.32v-766.19c0-69.1 56.22-125.32 125.32-125.32h766.19c69.1 0 125.32 56.22 125.32 125.32v766.19c0 69.1-56.22 125.32-125.32 125.32ZM621.32 956.86c-46.2 0-83.78 37.58-83.78 83.78v766.19c0 46.2 37.58 83.78 83.78 83.78h766.19c46.2 0 83.78-37.58 83.78-83.78v-766.19c0-46.2-37.58-83.78-83.78-83.78H621.32Z"
          className="cls-apr31"
        />
        <path
          d="M1058.14 927.47c-3.14-20.38-2.47-38.79 1.98-54.73.06-.23.13-.47.2-.7-1.82-2.24-3.57-4.58-5.26-7-13.93-20.06-21.13-42.91-20.27-64.34.13-3.19.43-6.3.9-9.33-8.22-7.37-14.9-17.62-18.07-31.87-5.67-25.53 1.96-56.88 19.9-81.81l11.58 8.33c-15.4 21.41-22.29 49.04-17.55 70.4 1.67 7.54 4.67 13.64 8.5 18.58 9.26-24.18 29.12-40.85 47.52-47.25 18.04-6.27 34.59-3.28 44.27 8 8.7 10.14 13.42 29.07 10.75 43.1-2.23 11.71-9.69 20.61-21.56 25.73-8.95 3.86-18.23 4.68-22.69 5.07-1.71.15-27.06 2.13-49.25-9.18-.01.27-.03.54-.04.81-.77 19.29 6.56 39.15 17.4 55.01 12.51-24.87 33.94-36.86 50.55-39.56 16.53-2.69 31.27 2.93 39.44 15.01 5.9 8.73 8.95 21.28 7.78 31.97-1.27 11.55-7.61 21.88-17.86 29.08-12.58 8.84-29.59 12.12-44.4 8.56-9.92-2.39-20.31-8.36-29.87-16.93-2.16 12.12-2.11 26.08.16 40.86l-14.09 2.17Zm18.33-58.66c9.03 9.58 19.21 16.38 28.8 18.69 10.78 2.59 23.68.09 32.87-6.36 4.84-3.41 10.84-9.46 11.89-18.97.8-7.3-1.43-16.52-5.42-22.43-5.04-7.46-14.28-10.71-25.34-8.92-15.36 2.5-33.68 15.14-42.8 38Zm-24.9-83.4c19.01 12.12 43.97 10.17 45.51 10.03 12.15-1.07 28.62-4.22 31.49-19.27 1.86-9.73-1.68-24.29-7.56-31.14-5.71-6.66-16.47-8.09-28.76-3.81-16.37 5.69-34.15 21.38-40.67 44.19Z"
          className="cls-apr31"
        />
        <path
          d="M1156.4 632.87c11.85 18.82 35.61 29.03 57.26 25.63 27.64-4.34 48.74-30.36 41.55-58.36 5.09 2.87 37.76 20.69 72.27 11.04 38.39-10.74 64.66-51.47 53.51-96.29 20.4 10.23 44.53 2.11 50.57-11.25 5.32-11.77-2.95-28.59-21.84-35.1 20.19-19.2 22.98-47.08 7.3-67.73-13.97-18.4-40.33-28.09-66.83-24.48-6.16-20-24.56-35.68-48.09-40.91-24.62-5.47-51.06 1.34-68.19 17.56-1.43-.74-22.08-10.97-43.51-2.1-16.16 6.69-21.59 19.62-22.61 22.2-3.8 86.6-7.6 173.19-11.39 259.79Z"
          className="cls-apr33"
        />
        <path
          d="M1409.72 468.54c20.18-19.2 22.98-47.08 7.3-67.73-13.88-18.28-39.98-27.95-66.3-24.54-.29.14-.58.28-.87.43 17.98 1.92 34.25 10.01 44.04 22.55 14.71 18.83 12.07 44.26-6.87 61.78 17.72 5.93 25.47 21.27 20.48 32-5.67 12.19-28.31 19.61-47.44 10.28 10.44 40.87-14.21 78.02-50.23 87.83-32.38 8.81-63.02-7.43-67.79-10.05 6.73 25.53-13.07 49.27-39 53.24-16.36 2.5-34.02-3.05-46.07-14.28-.19 4.27-.37 8.54-.56 12.81 11.85 18.83 35.62 29.03 57.26 25.63 27.64-4.34 48.73-30.36 41.55-58.36 5.09 2.87 37.76 20.69 72.27 11.04 38.39-10.74 64.65-51.46 53.51-96.29 20.41 10.23 44.54 2.11 50.57-11.25 5.32-11.76-2.95-28.58-21.84-35.1Z"
          className="cls-apr34"
        />
        <path
          d="M834.73 636.48c-11.43 19.09-34.95 29.82-56.67 26.91-27.73-3.72-49.4-29.26-42.85-57.41-5.03 2.98-37.29 21.53-72 12.66-38.63-9.88-65.8-50-55.66-95.06-20.17 10.69-44.47 3.11-50.81-10.11-5.58-11.64 2.3-28.64 21.05-35.58-20.61-18.75-24.03-46.55-8.82-67.55 13.55-18.71 39.69-28.98 66.26-25.97 5.71-20.14 23.75-36.22 47.16-41.98 24.49-6.02 51.07.19 68.57 16.02 1.41-.77 21.83-11.47 43.45-3.08 16.3 6.33 22.03 19.13 23.1 21.69l17.22 259.47Z"
          className="cls-apr33"
        />
        <path
          d="M577.79 477.87c-20.61-18.75-24.03-46.55-8.81-67.55 13.46-18.59 39.34-28.84 65.74-26.02.3.13.59.27.88.41-17.93 2.32-34.02 10.78-43.52 23.53-14.28 19.16-11.08 44.52 8.25 61.61-17.58 6.33-24.99 21.84-19.76 32.45 5.94 12.06 28.74 18.97 47.66 9.21-9.52 41.1 15.96 77.68 52.19 86.68 32.57 8.09 62.83-8.84 67.55-11.56-6.16 25.68 14.17 48.97 40.18 52.35 16.42 2.13 33.94-3.81 45.74-15.31.28 4.26.56 8.53.85 12.79-11.43 19.09-34.95 29.82-56.67 26.91-27.73-3.72-49.4-29.26-42.85-57.41-5.03 2.98-37.28 21.53-72 12.66-38.62-9.88-65.79-50-55.66-95.06-20.17 10.69-44.48 3.11-50.81-10.12-5.58-11.64 2.31-28.64 21.05-35.58Z"
          className="cls-apr34"
        />
        <path
          d="m1059.76 309.85-152.68 1.71c-14.78.17-27.71-9.91-31.16-24.28l-37.73-157.02c-4.75-19.78 10.11-38.86 30.45-39.09l226.28-2.54c20.48-.23 35.79 18.73 31.25 38.7l-35.87 157.85c-3.25 14.3-15.88 24.5-30.54 24.66Z"
          className="cls-apr33"
        />
        <path
          d="m1098.21 250.39-7.91 34.79c-3.25 14.3-15.88 24.5-30.55 24.66l-152.68 1.71c-14.78.17-27.71-9.91-31.16-24.28l-37.73-157.02c-4.25-17.69 7.19-34.82 24.2-38.4l34.06 141.76c3.45 14.37 16.39 24.45 31.17 24.28l152.68-1.71c6.6-.07 12.81-2.19 17.92-5.8Z"
          className="cls-apr34"
        />
        <ellipse
          cx={993.93}
          cy={489.12}
          rx={224.45}
          ry={212.22}
          style={{
            fill: "#f8d8cb",
          }}
          transform="rotate(-.64 998.16 491.704)"
        />
        <path
          d="M1226.11 518.43c12.68 82.89-107.23 204.49-235.96 203.52-124.41-.93-239.96-116.64-230.87-201.78.56-5.21 5.5-46.34 34.35-60.82 52.9-26.56 106.76 76.32 200.23 72.79 88.85-3.36 128.13-98.85 185.9-78.07 27.18 9.78 42.79 41.09 46.35 64.37Z"
          className="cls-apr31"
        />
        <path
          d="M990.89 722.64C867.61 721.71 753.04 608.1 759.8 523.2c7.99 82.32 115.63 181.69 230.9 182.56 118.7.89 229.91-102.43 236.56-183.52 9.28 82.78-109.25 201.36-236.37 200.41Z"
          className="cls-apr35"
        />
        <circle cx={993.93} cy={489.12} r={66.56} className="cls-apr33" />
        <path
          d="M1060.49 488.37c.41 36.76-29.05 66.9-65.81 67.31-18.87.21-36-7.45-48.25-19.93 11.25 8.33 25.21 13.18 40.28 13.01 36.76-.41 66.22-30.54 65.81-67.3-.2-17.89-7.44-34.05-19.06-45.88 16.19 11.96 26.78 31.11 27.03 52.8Z"
          className="cls-apr34"
        />
        <path
          d="M1056.91 650.73c-18.3 11.18-39.17 18.38-62.48 18.83-20.4.4-39.2-4.44-56.18-12.63-72.87-35.12-112.49-131.88-103.21-141.49 9.42-9.76 68.22 71.24 158.42 68.29 91.13-2.98 145.31-89.37 155-80.57 9.38 8.51-23.2 105.8-91.56 147.56Z"
          style={{
            fill: "#590e1e",
          }}
        />
        <path
          d="m1151.26 344.17-333.3 3.74c-4.55.05-8.9-1.92-11.86-5.38l-32.47-37.92c-8.5-9.92-1.55-25.24 11.51-25.39l400.72-4.5c13.42-.15 20.58 15.75 11.59 25.7l-34.95 38.67a15.407 15.407 0 0 1-11.24 5.07Z"
          className="cls-apr31"
        />
        <path
          d="m1197.45 300.43-34.95 38.67a15.39 15.39 0 0 1-11.24 5.07l-333.3 3.74c-4.55.05-8.9-1.92-11.86-5.37l-32.47-37.92c-3.05-3.56-4.11-7.81-3.61-11.81.51.94 1.14 1.85 1.88 2.71l32.47 37.91c2.97 3.45 7.31 5.42 11.86 5.37l333.3-3.74c4.29-.05 8.37-1.88 11.24-5.07l34.95-38.67c2.3-2.55 3.55-5.49 3.9-8.45 2.83 5.34 2.6 12.28-2.16 17.55Z"
          className="cls-apr35"
        />
        <path
          d="M937.47 432.05c-1.38 0-2.78-.43-3.97-1.33l-45.32-34.33a6.58 6.58 0 0 1-1.27-9.21 6.58 6.58 0 0 1 9.21-1.27l45.32 34.33a6.58 6.58 0 0 1 1.27 9.21 6.552 6.552 0 0 1-5.25 2.6Z"
          className="cls-apr31"
        />
        <path
          d="M892.55 432.55c-1.94 0-3.86-.85-5.15-2.49-2.26-2.84-1.78-6.98 1.06-9.24L933 385.48c2.84-2.26 6.98-1.78 9.24 1.06s1.78 6.98-1.06 9.24l-44.54 35.34a6.536 6.536 0 0 1-4.08 1.42ZM1089.19 430.35c-1.38 0-2.78-.43-3.97-1.33l-45.32-34.33a6.58 6.58 0 0 1-1.27-9.21 6.58 6.58 0 0 1 9.21-1.27l45.32 34.33a6.58 6.58 0 0 1 1.27 9.21 6.552 6.552 0 0 1-5.25 2.6Z"
          className="cls-apr31"
        />
        <path
          d="M1044.28 430.85c-1.94 0-3.86-.85-5.15-2.49-2.26-2.84-1.78-6.98 1.06-9.24l44.53-35.34c2.84-2.26 6.98-1.78 9.24 1.06s1.78 6.98-1.06 9.24l-44.53 35.34a6.536 6.536 0 0 1-4.08 1.42Z"
          className="cls-apr31"
        />
        <path
          d="M1056.97 649.33c0 .47-.01.94-.06 1.41-18.3 11.18-39.17 18.38-62.48 18.83-20.4.4-39.2-4.44-56.18-12.63-.99-2.01-1.52-4.11-1.55-6.26-.18-15.7 26.6-28.73 59.81-29.1 33.21-.37 60.27 12.05 60.45 27.75Z"
          style={{
            fill: "#c40a32",
          }}
        />
        <ellipse
          cx={951.74}
          cy={480.89}
          className="cls-apr37"
          rx={15.85}
          ry={13.69}
          transform="rotate(-.64 956.13 483.412)"
        />
        <ellipse
          cx={955.04}
          cy={455.44}
          className="cls-apr37"
          rx={6.03}
          ry={5.21}
          transform="rotate(-.64 959.855 457.47)"
        />
        {children}
      </g>
    </svg>
  );
}
